import { Box, makeStyles, Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { Field, Form, Formik, FormikProps } from 'formik'
import { Button } from '@src/stories/Buttons/Button'
import LiquidSelectAdapter from '@src/components/LiquidSelectAdapter/LiquidSelectAdapter'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import PartnerAddressSearchFields from './PartnerAddressSearchFields'

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    paddingBottom: theme.spacing(5),
    position: 'relative',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(5),

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      maxWidth: '50%',
    },
  },
  orderInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(5),
    alignItems: 'flex-end',
    '& div': {
      width: '100%',
    },

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',

      '& div': {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 0,
      },
    },
  },
  actionContainer: {
    position: 'relative',
  },
  searchButton: {
    minWidth: '100%',
  },
  clearButton: {
    position: 'absolute',
    top: 38,
    right: -28,
    fontSize: theme.typography.pxToRem(14),
  },
}))

const MDSearchForm = () => {
  const classes = useStyles()

  return (
    <Formik
      initialValues={{
        contactParty: '',
        shipToList: [''],
        status: '',
        orderNo: '',
        poNo: '',
        customerMaterialNo: '',
        lotNo: '',
        page: 1,
        pageSize: 10,
        soldTo: '',
      }}
      onSubmit={(values) => {
        console.warn('values: ', values)
      }}
      enableReinitialize
    >
      {(formikBag: FormikProps<any>) => {
        return (
          <Form className={classes.form}>
            <Box className={classes.userInfo}>
              <PartnerAddressSearchFields formikBag={formikBag} />
            </Box>

            <Box className={classes.orderInfo}>
              <Field
                name="status"
                component={LiquidSelectAdapter}
                label={<FormattedMessage id="Status" defaultMessage="Status" />}
                options={[
                  { label: 'All', value: 1 },
                  { label: 'Open', value: 2 },
                  { label: 'Closed', value: 3 },
                ]}
              />

              <Field
                name="orderNumber"
                component={LiquidInputAdapter}
                label={
                  <FormattedMessage
                    id="ORDER_NUMBER"
                    defaultMessage="Order Number"
                  />
                }
                data-testid="order-number-input"
              />

              <Field
                name="poNumber"
                component={LiquidInputAdapter}
                label={
                  <FormattedMessage id="PO_NUMBER" defaultMessage="PO Number" />
                }
                data-testid="po-number-input"
              />

              <Field
                name="customerPart"
                component={LiquidInputAdapter}
                label={
                  <FormattedMessage
                    id="CUSTOMER_PART"
                    defaultMessage="Customer Part"
                  />
                }
                data-testid="customer-part-input"
              />

              <Field
                name="lotNumber"
                component={LiquidInputAdapter}
                label={
                  <FormattedMessage
                    id="LOT_NUMBER"
                    defaultMessage="Lot Number"
                  />
                }
                data-testid="lot-number-input"
              />

              <Box className={classes.actionContainer}>
                <Button
                  data-testid="submit-btn"
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="medium"
                  className={classes.searchButton}
                >
                  <FormattedMessage id="SEARCH" defaultMessage="Search" />
                </Button>
                <Button
                  data-testid="submit-btn"
                  variant="text"
                  color="primary"
                  type="submit"
                  size="medium"
                  className={classes.clearButton}
                >
                  <FormattedMessage
                    id="CLEAR_FILTERS"
                    defaultMessage="Clear Filters"
                  />
                </Button>
              </Box>
            </Box>
          </Form>
        )
      }}
    </Formik>
  )
}

export default MDSearchForm
